import { isProspectStage } from "../../Enums/ClientStatus.enum";

export type OnboardingCardMode = "onboarding" | "audit" | "none";

/**
 * Which onboarding card the Overview shows (CR.2/CR.3): prospect-stage clients get
 * the full onboarding card; current/dormant (and no-status) clients get only a
 * small audit card when an onboarding was submitted, and nothing otherwise.
 */
export const resolveOnboardingCardMode = (
  clientStatusID: number | null | undefined,
  hasSubmittedOnboarding: boolean,
): OnboardingCardMode => {
  if (isProspectStage(clientStatusID)) return "onboarding";
  return hasSubmittedOnboarding ? "audit" : "none";
};

/** The card's primary button label (CR.2). */
export const onboardingButtonLabel = (
  completedSteps: number,
  isSubmitted: boolean,
): string => {
  if (isSubmitted) return "View Onboarding";
  return completedSteps === 0 ? "Start Onboarding" : "Continue Onboarding";
};
